import { AlertsSignup } from "@/components/AlertsSignup";

export default function Alerts() {
  return (
    <div className="wyv-container py-12 sm:py-16">
      <div className="max-w-2xl">
        <h1 className="font-heading font-bold text-3xl sm:text-4xl text-foreground" data-testid="alerts-title">
          Sign up for alerts
        </h1>
        <p className="text-muted-foreground mt-3 leading-relaxed">
          Election reminders, new participating candidates, municipal accountability investigations and PITA updates.
          Alert subscriptions are stored completely separately from voter declaration data, and you can unsubscribe
          at any time by contacting support@witnessyourvote.ca.
        </p>
      </div>
      <div className="mt-8 max-w-2xl">
        <AlertsSignup />
      </div>
    </div>
  );
}
